/**
 * ButtonSection
 * Использует переиспользуемые компоненты
 */
import { Button, Text, Container } from '../components';

export default function ButtonSection({ data, styles }) {
  const alignment = data?.alignment || 'center';
  const variant = data?.variant || 'primary';
  const size = data?.size || 'default';
  const fullWidth = data?.fullWidth || false;

  // Получаем данные текста (поддержка старого и нового формата)
  const textData = typeof data?.text === 'object' ? data.text : { text: data?.text || 'Кнопка' };

  const getAlignmentClass = () => {
    switch (alignment) {
      case 'left': return 'justify-start';
      case 'right': return 'justify-end';
      default: return 'justify-center';
    }
  };

  const handleClick = () => {
    const link = data?.link;
    if (link?.startsWith('#')) {
      const el = document.querySelector(link);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else if (link) {
      window.location.href = link;
    }
  };

  return (
    <section
      style={{
        paddingTop: styles?.paddingTop || 32,
        paddingBottom: styles?.paddingBottom || 32,
        backgroundColor: styles?.backgroundColor || 'transparent'
      }}
    >
      <Container>
        <div className={`flex ${getAlignmentClass()}`}>
          <Button
            variant={variant === 'primary' ? 'default' : 'outline'}
            size={size}
            onClick={handleClick}
            fullWidth={fullWidth}
            className={`${fullWidth ? 'w-full max-w-md' : ''} ${variant !== 'primary' ? 'border-primary text-primary hover:bg-primary/10' : ''}`}
          >
            <Text
              as="span"
              data={textData}
              defaults={{ size: 'base', weight: 'medium', color: 'inherit' }}
            />
          </Button>
        </div>
      </Container>
    </section>
  );
}
